import { Routes } from '@angular/router';
import { authGuard } from './pages/auth/guards/auth.guard';
import { roleGuard } from './pages/auth/guards/role.guard';
import { territorialIntelligenceGuard } from './pages/auth/guards/territorial-intelligence.guard';

export const routes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login').then(
            (c) => c.LoginComponent
          ),
      },
      {
        path: 'login/quiron',
        loadComponent: () =>
          import('./pages/auth/login-types/quiron/login-quiron.component').then(
            (c) => c.LoginQuironComponent
          ),
      },
      {
        path: 'recuperar-senha',
        loadComponent: () =>
          import('./pages/auth/recovery-form/recovery-form.component').then(
            (c) => c.RecoveryFormComponent
          ),
      },
      {
        path: 'redefinePassword',
        loadComponent: () =>
          import('./pages/auth/define-password/define-password.component').then(
            (c) => c.DefinePasswordComponent
          ),
      }
    ]
  },
  {
    path: 'login',
    children: [
      {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full'
      },
      {
        path: 'redefinePassword',
        loadComponent: () =>
          import('./pages/auth/define-password/define-password.component').then(
            (c) => c.DefinePasswordComponent
          ),
      },
      {
        path: 'firstAccess',
        loadComponent: () =>
          import('./pages/auth/define-password/define-password.component').then(
            (c) => c.DefinePasswordComponent
          ),
      }
    ]
  },
  {
    path: 'export/area-evaluation/:id/pdf',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/discover/market-intelligence/area-evaluation-pdf-export/area-evaluation-pdf-export.component').then(
        (c) => c.AreaEvaluationPdfExportComponent
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/layout.component').then(
        (c) => c.LayoutComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'market-intelligence',
        pathMatch: 'full'
      },
      {
        path: 'territorial-intelligence',
        canActivate: [territorialIntelligenceGuard],
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
          },
          {
            path: 'dashboard',
            data: { view: 'dashboard' },
            loadComponent: () =>
              import('./pages/discover/territorial-intelligence/territorial-intelligence.component').then(
                c => c.TerritorialIntelligenceComponent
              ),
          },
          {
            path: 'settings',
            canActivate: [roleGuard],
            data: { roles: ['Owner'], view: 'settings' },
            loadComponent: () =>
              import('./pages/discover/territorial-intelligence/territorial-intelligence.component').then(
                c => c.TerritorialIntelligenceComponent
              ),
          }
        ]
      },
      {
        path: 'maps-visualization',
        loadComponent: () =>
          import('./pages/discover/maps-visualization/maps-visualization.component').then(
            c => c.MapsVisualizationComponent
          ),
      },
      {
        path: 'market-intelligence',
        loadComponent: () =>
          import('./pages/discover/market-intelligence/market-intelligence.component').then(
            c => c.MarketIntelligenceComponent
          ),
      },
      {
        path: 'market-intelligence/:id',
        loadComponent: () =>
          import('./pages/discover/market-intelligence/market-intelligence-view/view/market-intelligence-view.component').then(
            c => c.MarketIntelligenceViewComponent
          ),
      },
      {
        path: 'points-interest',
        loadComponent: () =>
          import('./pages/discover/points-interest/points-interest.component').then(
            c => c.PointsInterestComponent
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then(
            c => c.SettingsComponent
          ),
      },
      {
        path: 'settings/integration-key',
        redirectTo: '/settings',
        pathMatch: 'full'
      },
      {
        path: 'admin',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['Owner', 'Admin'] },
        children: [
          {
            path: '',
            redirectTo: 'users',
            pathMatch: 'full'
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./pages/admin/users/users.component').then(
                c => c.UsersComponent
              ),
          },
          {
            path: 'customers',
            canActivate: [roleGuard],
            data: { roles: ['Owner'] },
            loadComponent: () =>
              import('./pages/admin/customers/customers.component').then(
                c => c.CustomersComponent
              ),
          },
          {
            path: 'info-extraidas',
            loadComponent: () =>
              import('./pages/admin/info-extraidas/info-extraidas.component').then(
                c => c.InfoExtraidasComponent
              ),
          },
          {
            path: 'locais-estrategicos',
            canActivate: [roleGuard],
            data: { roles: ['Owner'] },
            loadComponent: () =>
              import('./pages/admin/locais-estrategicos/locais-estrategicos.component').then(
                c => c.LocaisEstrategicosComponent
              ),
          }
        ]
      }
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
